import $ from 'jquery';

const CLOSE_BUTTON_SELECTOR = '.notification-bar__close, .notification-bar__btn-close';

$(CLOSE_BUTTON_SELECTOR).click(function (e) {
	e.preventDefault();
	$(this).closest('.module-container').remove();
});
